<template>
  <v-col>
    <v-row class="my-0">
      <h2 class="mb-2">{{ $translate('YOUR_ORDER') }}</h2>
      <v-list style="width: 100% !important" class="py-0" dense>
        <template v-for="(order, orderIndex) in ordersInCart">
          <!-- Order item for Products, VirtualProducts and Rentals -->
          <div
            v-if="
              order.ShoppingCartType === 'Product' ||
              order.ShoppingCartType === 'Rental' ||
              order.ShoppingCartType === 'VirtualProduct'
            "
            :key="`prod-order-${orderIndex}`"
          >
            <template
              v-for="(productObject, productObjectIndex) in order.Products"
            >
              <v-list-item
                :key="`product-${productObjectIndex}`"
                dense
                class="px-2"
              >
                <v-list-item-avatar
                  size="100"
                  class="ma-0 my-1 mr-3"
                  tile
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  <v-img
                    v-if="productObject.PictureUrl.length > 0"
                    contain
                    :aspect-ratio="1.618"
                    :src="productObject.PictureUrl"
                  />
                  <v-icon v-else x-large color="secondary">image</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-card flat color="grey lighten-4" class="px-3">
                    <v-row class="my-0">
                      <v-col cols="6" class="pr-2">
                        <v-list-item-title class="mb-1">
                          {{ productObject.ProductName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ $translate('QUANTITY') }}:
                          {{
                            getDisplayQuantity(
                              productObject,
                              productObject.Quantity
                            )
                          }}
                          {{ getDisplayUnit(productObject) }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          v-if="productObject.ProductType === 'Rental'"
                          class="mt-1"
                        >
                          <span v-if="order.StartDate !== order.EndDate">
                            {{ order.StartDate }} {{ order.StartTime }} -
                            {{ order.EndDate }} {{ order.EndTime }}
                          </span>
                          <span v-else>
                            {{ order.StartDate }}
                            {{ order.StartTime }} - {{ order.EndTime }}
                          </span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          v-if="
                            productObject.Aspects != null &&
                            productObject.Aspects.trim() !== ''
                          "
                          class="mt-1"
                        >
                          {{ productObject.Aspects }}
                        </v-list-item-subtitle>
                        <!-- Product options -->
                        <v-list-item-subtitle
                          v-if="
                            productObject.OrderProductOptionsSummary != null &&
                            productObject.OrderProductOptionsSummary.trim() !==
                              ''
                          "
                          class="mt-1"
                        >
                          {{ productObject.OrderProductOptionsSummary }}
                        </v-list-item-subtitle>
                      </v-col>

                      <v-col cols="6" class="pl-2">
                        <!-- <v-list-item-title>
                          <span
                            v-if="showProductRetailPrice(productObject)"
                            class="discount-price text-caption text--secondary mr-1"
                          >
                            {{
                              formatter.format(
                                getProductTotalRetailPrice(productObject)
                              )
                            }}
                          </span>
                          {{
                            formatter.format(
                              getProductTotalPrice(productObject)
                            )
                          }}
                        </v-list-item-title> -->
                        <!-- <span
                          v-if="isProfUser"
                          class="text-caption text--secondary"
                        >
                          {{ $translate('EXCL_VAT') }}
                        </span> -->
                        <v-row class="ma-0" justify="end">
                          <ShoppingListProductActions
                            :product="productObject"
                            :totalPrice="getProductTotalPrice(productObject)"
                            :quantity="
                              getDisplayQuantity(
                                productObject,
                                productObject.Quantity
                              )
                            "
                            :isWeighted="
                              productObject.ProductType === 'Weighted'
                            "
                            :unit="getDisplayUnit(productObject)"
                            :decreaseBtnDisabled="
                              isDecreaseBtnDisabled(productObject)
                            "
                            :increaseBtnDisabled="
                              isIncreaseBtnDisabled(productObject)
                            "
                            @decrease="
                              onAddOrSubtractsProduct(
                                'subtracts',
                                productObject,
                                order,
                                orderIndex
                              )
                            "
                            @increase="
                              onAddOrSubtractsProduct(
                                'add',
                                productObject,
                                order,
                                orderIndex
                              )
                            "
                            @delete="
                              removeOrderFromShoppingCart(
                                order,
                                orderIndex,
                                productObject.ItemId,
                                productObject.OrderItemId
                              )
                            "
                          />
                        </v-row>
                      </v-col>
                      <v-row class="ma-0">
                        <v-col class="pa-0">
                          <ProductAvailabilityDetails
                            :item="productObject.Product"
                          ></ProductAvailabilityDetails>
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template
              v-for="(
                priceCategory, priceCategoryIndex
              ) in order.PriceCategories"
            >
              <v-list-item :key="`pc-${priceCategoryIndex}`" dense class="px-2">
                <v-list-item-avatar
                  size="100"
                  class="ma-0 my-1 mr-3"
                  tile
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  <v-icon color="primary" x-large>confirmation_number</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-card flat color="grey lighten-4" class="px-3">
                    <v-row class="my-0">
                      <v-col cols="8">
                        <v-list-item-title>
                          {{ priceCategory.PriceCategoryName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ $translate('QUANTITY') }}:
                          {{ priceCategory.Quantity }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          {{ priceCategory.PriceCategoryDescription }}
                        </v-list-item-subtitle>
                      </v-col>
                      <v-col cols="4" class="text-right">
                        <v-list-item-title>
                          {{
                            formatter.format(
                              getPriceCategoryPrice(priceCategory)
                            )
                          }}
                        </v-list-item-title>
                        <span
                          v-if="isProfUser"
                          class="text-caption text--secondary"
                        >
                          {{ $translate('EXCL_VAT') }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </template>
          </div>
          <!-- Order item for Tickets -->
          <v-list-item
            v-if="order.ShoppingCartType === 'Ticket'"
            :key="`ticket-order-${orderIndex}`"
            class="px-2"
          >
            <v-list-item-avatar
              v-if="$vuetify.breakpoint.mdAndUp"
              size="100"
              class="ma-0 my-1 mr-3"
              tile
            >
              <v-img
                v-if="order.Picture.length > 0"
                contain
                :aspect-ratio="16 / 9"
                :src="order.Picture"
              />
              <v-icon v-else x-large color="secondary">image</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-card flat color="grey lighten-4" class="px-3">
                <v-row class="my-0">
                  <v-col cols="8">
                    <v-list-item-title>
                      {{ order.Name }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-for="(
                        priceCategory, priceCategoryIndex
                      ) in order.PriceCategories"
                      :key="priceCategoryIndex"
                    >
                      {{ priceCategory.PriceCategoryName }}
                      ({{ priceCategory.Quantity }} *
                      {{
                        formatter.format(getPriceCategoryPrice(priceCategory))
                      }})
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ $translate('DATE') }} : {{ order.StartDate }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ $translate('TIME') }} :
                      {{ order.StartTime }}
                    </v-list-item-subtitle>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <v-list-item-title>
                      {{ formatter.format(getOrderTotalPrice(order)) }}
                    </v-list-item-title>
                    <span
                      v-if="isProfUser"
                      class="text-caption text--secondary"
                    >
                      {{ $translate('EXCL_VAT') }}
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-list-item-content>
          </v-list-item>
          <!-- Order item for Special Request-->
          <v-list-item
            v-if="order.ShoppingCartType === 'SpecialRequest'"
            :key="`request-order-${orderIndex}`"
            class="px-2"
          >
            <v-list-item-avatar size="100" class="ma-0 my-1 mr-3" tile>
              <v-icon color="primary" x-large>message</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-card flat color="grey lighten-4" class="px-3">
                <v-row class="my-0">
                  <v-col cols="8">
                    <v-list-item-title>
                      <b>
                        {{ order.MainOrder.Name }}
                      </b>
                    </v-list-item-title>
                    <v-card-text>
                      {{ order.MainOrder.SpecialRequests[0].SpecialRequest }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="4">
                    <v-list-item-subtitle
                      class="subtotal black--text text-right"
                    >
                      <b>{{ $translate('SPECIAL_REQUEST') }}</b>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-card>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="dividerStyle" :key="orderIndex + 9999"></v-divider>
        </template>
      </v-list>
    </v-row>
  </v-col>
</template>

<script>
import {
  isWeightedProduct,
  getDisplayQuantity,
  getDisplayUnit,
  quantityDecreasable,
  quantityIncreasable,
} from '@/objects/Product';
import ProductAvailabilityDetails from '@/components/event/eventDetails/productOrderComponents/ProductAvailabilityDetails';
import ShoppingListProductActions from '@/components/shoppingLists/ShoppingListProductActions';

export default {
  name: 'Booking_Product_List',
  computed: {
    ordersInCart() {
      return this.$store.getters['shoppingCart/orders'];
    },
    isProfUser() {
      return this.$store.getters.isProfUser;
    },
  },
  components: {
    ProductAvailabilityDetails,
    ShoppingListProductActions,
  },
  data() {
    return {
      productShoppingCart: [],
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  mounted() {
    this.productShoppingCart = this.$store.getters[
      'shoppingCart/orders'
    ].filter((item) => item.ShoppingCartType === 'Product');
  },
  methods: {
    getDisplayQuantity,
    getDisplayUnit,
    getProductPrice(product) {
      if (this.isProfUser) {
        return product.ItemPrice - product.ItemVatPrice;
      }
      return product.ItemPrice;
    },
    getProductTotalPrice(product) {
      console.log('getProductTotalPrice', product);
      if (this.isProfUser) {
        console.log('IsProfUser');
        return product.ItemTotalPrice - product.ItemTotalVatPrice;
      }
      return product.ItemTotalPrice;
    },
    getPriceCategoryPrice(priceCategory) {
      if (this.isProfUser) {
        return (
          priceCategory.PriceCategoryPrice - priceCategory.PriceCategoryVatPrice
        );
      }
      return priceCategory.PriceCategoryPrice;
    },
    getOrderTotalPrice(order) {
      if (this.isProfUser) {
        return order.OrderTotalPrice - order.OrderTotalPriceVat;
      }
      return order.OrderTotalPrice;
    },
    showProductRetailPrice(product) {
      const retailPriceShown = Number(
        this.getProductTotalRetailPrice(product)
      ).toFixed(2);
      const priceShown = Number(this.getProductTotalPrice(product)).toFixed(2);

      return retailPriceShown > 0 && retailPriceShown > priceShown;
    },
    getProductTotalRetailPrice(product) {
      let amount = product.Quantity;
      if (isWeightedProduct(product)) {
        amount = product.Quantity / product.StepSize;
      }

      if (this.isProfUser) {
        return amount * (product.ItemRetailPrice - product.ItemRetailVatPrice);
      }
      return amount * product.ItemRetailPrice;
    },
    isDecreaseBtnDisabled(product) {
      if (product.ProductType === 'Rental') {
        return true;
      }

      return !quantityDecreasable(
        product.Product,
        product.Item,
        product.Quantity
      );
    },
    isIncreaseBtnDisabled(product) {
      if (product.ProductType === 'Rental') {
        return true;
      }

      return !quantityIncreasable(
        product.Product,
        product.Item,
        product.Quantity
      );
    },
    onAddOrSubtractsProduct(action, product, order, orderIndex) {
      // Add timeout id to the product to delay the backend request for changeProduct
      if (typeof product.timeoutId === 'number') {
        clearTimeout(product.timeoutId);
      }

      switch (action) {
        case 'add':
          if (product.ProductType === 'Weighted') {
            product.Quantity += product.StepSize;
            product.Amount = product.Quantity;
          } else {
            product.Quantity += 1;
          }
          break;
        case 'subtracts':
          if (product.ProductType === 'Weighted') {
            product.Quantity -= product.StepSize;
            product.Amount = product.Quantity;
          } else {
            product.Quantity -= 1;
          }
          break;
        default:
          break;
      }

      product.timeoutId = setTimeout(() => {
        this.addOrSubtractsProduct(product, order, orderIndex);
      }, 1 * 1000);
    },
    addOrSubtractsProduct(product, order, orderIndex) {
      product.EventId = order.EventId;

      let minQuantity = 1;
      if (product.ProductType === 'Weighted' && product.WeightedInfo != null) {
        minQuantity = product.WeightedInfo.Minimum;
      }

      if (product.Quantity >= minQuantity) {
        this.$store.commit('shoppingCart/changeProduct', product);
      } else {
        this.removeOrderFromShoppingCart(
          order,
          orderIndex,
          product.ItemId,
          product.OrderItemId
        );
      }
    },
    removeOrderFromShoppingCart(
      order,
      orderIndex,
      itemId = '',
      orderItemId = ''
    ) {
      const orderData = {
        orderIndex,
        itemId,
        orderItemId,
      };
      this.$store.commit('shoppingCart/removeOrder', orderData);
    },
  },
};
</script>
